import { inject, Injectable } from '@angular/core';
import { take } from 'rxjs';
import { ImgCompressionService } from '../img-compression/img-compression.service';
import { ModalService } from '../modal/modal.service';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  private readonly imgCompressionService = inject(ImgCompressionService);
  private readonly modalService = inject(ModalService);
  constructor() {}
  /**
   * @description
   * This method is used to convert a file to base64
   * And check if the file type is allowed
   * @param {File} file
   * @param {string[]} allowedFileTypes
   * @returns {Promise<string[]>} [base64, fileType]
   */
  async onFileChange(file: File, allowedFileTypes: string[], withoutCompress?: boolean): Promise<string[]> {
    let reader = new FileReader();
    return new Promise((resolve, reject) => {
      if (!this.checkFileType(file.type, allowedFileTypes) && allowedFileTypes[0] !== 'all') {
        reject('Type de fichier non autorisé');
      } else {
        if (file.type.includes('image') && !file.type.includes('png') && !withoutCompress) {
          this.imgCompressionService
            .compress(file)
            .pipe(take(1))
            .subscribe((compressedFile) => {
              reader.readAsDataURL(compressedFile);
            });

          ((reader.onload = () => {
            resolve([reader.result as string, file.name.split('.')[1]]);
          }),
            (reader.onerror = (error) => {
              this.modalService.openAlert('error', 'Erreur', 'Erreur lors de la lecture du fichier', () => {
                this.modalService.closeAlert();
              });
            }));
        } else {
          reader.readAsDataURL(file);
          reader.onload = () => {
            resolve([reader.result as string, file.name.split('.')[1]]);
          };
          reader.onerror = (error) => {
            reject(error);
          };
        }
      }
    });
  }
  /**
   * @description
   * This method is used to check if the file type is allowed
   * @param {string} fileType
   * @param {string[]} allowedFileTypes
   * @returns {boolean}
   */
  checkFileType(fileType: string, allowedFileTypes: string[]) {
    return allowedFileTypes.includes(fileType);
  }

  getUrlFromBase64(base64: string): string {
    const cleanedBase64 = base64.split(',')[1]; // enlève le préfixe
    const blob = this.b64toBlob(cleanedBase64, 'image/jpeg');
    return URL.createObjectURL(blob);
  }

  b64toBlob(b64Data: string, contentType: string, sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }

  convertFileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result as string);
      };
      reader.onerror = (error) => {
        reject(error);
      };
    });
  }
}
